export default __webpack_public_path__ + "static/media/lDAI.85c9c2fd.png";